@if (showBell) {
  <button
    type="button"
    class="notifications-bell"
    (click)="openNotifications()"
    [attr.aria-label]="
      unreadCount > 0 ? 'Notificaciones, ' + unreadCount + ' sin leer' : 'Notificaciones, ninguna sin leer'
    "
  >
    <nz-badge [nzCount]="unreadCount" [nzOverflowCount]="99" nzStandalone>
      <i class="icon fe fe-bell" aria-hidden="true"></i>
    </nz-badge>
  </button>
}
